import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var getTelLink = function getTelLink(phoneNumber) {
  var _phoneNumber$country_, _context, _context2, _phoneNumber$extensio, _context6, _context7;
  var includeExtension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var cCode = (_phoneNumber$country_ = phoneNumber.country_code) !== null && _phoneNumber$country_ !== void 0 ? _phoneNumber$country_ : '1';
  var country = cCode === '01' ? '1' : cCode;
  var city = _sliceInstanceProperty(_context = phoneNumber.phone_number).call(_context, 0, 3);
  var number = _sliceInstanceProperty(_context2 = phoneNumber.phone_number).call(_context2, 3, 10);
  var extension = (_phoneNumber$extensio = phoneNumber.extension) !== null && _phoneNumber$extensio !== void 0 ? _phoneNumber$extensio : '';
  if (includeExtension && !!extension) {
    var _context3, _context4, _context5;
    return _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "tel:+".concat(country)).call(_context5, city)).call(_context4, number, ",")).call(_context3, extension);
  }
  return _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = "tel:+".concat(country)).call(_context7, city)).call(_context6, number);
};
export default getTelLink;
//# sourceMappingURL=getTelLink.js.map